import type { components } from '@/api/clarity'
import type { User } from '@firebase/auth'
import { inject, shallowRef, type InjectionKey, type ShallowRef } from 'vue'

export const userKey = Symbol() as InjectionKey<ShallowRef<User | null>>

export function injectUser() {
  return inject(userKey) || shallowRef<User | null>(null)
}

export function userDisplayName(user: User | null): string | undefined {
  return user?.displayName ?? user?.providerData?.find((p) => p.displayName)?.displayName ?? undefined
}

export const accountKey = Symbol() as InjectionKey<
  ShallowRef<components['schemas']['AccountResponseBody'] | undefined>
>

export function injectAccount() {
  return inject(accountKey) || shallowRef<components['schemas']['AccountResponseBody'] | undefined>()
}
